import { createAction } from '@reduxjs/toolkit';
import { OrganizationBrandingDTO, OrganizationBrandingEmailPreviewDTO } from '@reposit/api-client';
import {
  DeleteOrganizationBrandingPayload,
  FetchOrganizationBrandingPayload,
  PreviewOrganizationBrandingEmailPayload,
  UploadedOrganizationBrandingLogo,
  UploadOrganizationBrandingLogoPayload,
  UpsertOrganizationBrandingPayload,
} from './organization-branding.types';

export const FETCH_ORGANIZATION_BRANDING_STORE_KEY = 'ORGANIZATION_BRANDING/FETCH_ORGANIZATION_BRANDING';
export const UPSERT_ORGANIZATION_BRANDING_STORE_KEY = 'ORGANIZATION_BRANDING/UPSERT_ORGANIZATION_BRANDING';
export const DELETE_ORGANIZATION_BRANDING_STORE_KEY = 'ORGANIZATION_BRANDING/DELETE_ORGANIZATION_BRANDING';
export const UPLOAD_ORGANIZATION_BRANDING_LOGO_STORE_KEY = 'ORGANIZATION_BRANDING/UPLOAD_ORGANIZATION_BRANDING_LOGO';
export const PREVIEW_ORGANIZATION_BRANDING_EMAIL_STORE_KEY = 'ORGANIZATION_BRANDING/PREVIEW_ORGANIZATION_BRANDING_EMAIL';

export const fetchOrganizationBrandingRequested = createAction<FetchOrganizationBrandingPayload>(
  `${FETCH_ORGANIZATION_BRANDING_STORE_KEY}_API_REQUESTED`,
);
export const fetchOrganizationBrandingSuccess = createAction<{
  organizationId: string;
  profile: OrganizationBrandingDTO | null;
}>(`${FETCH_ORGANIZATION_BRANDING_STORE_KEY}_API_SUCCESS`);
export const fetchOrganizationBrandingFailed = createAction<{ organizationId: string; error: string }>(
  `${FETCH_ORGANIZATION_BRANDING_STORE_KEY}_API_FAILED`,
);

export const upsertOrganizationBrandingRequested = createAction<UpsertOrganizationBrandingPayload>(
  `${UPSERT_ORGANIZATION_BRANDING_STORE_KEY}_API_REQUESTED`,
);
export const upsertOrganizationBrandingSuccess = createAction<{
  organizationId: string;
  profile: OrganizationBrandingDTO;
}>(`${UPSERT_ORGANIZATION_BRANDING_STORE_KEY}_API_SUCCESS`);
export const upsertOrganizationBrandingFailed = createAction<{ organizationId: string; error: string }>(
  `${UPSERT_ORGANIZATION_BRANDING_STORE_KEY}_API_FAILED`,
);

export const uploadOrganizationBrandingLogoRequested = createAction<UploadOrganizationBrandingLogoPayload>(
  `${UPLOAD_ORGANIZATION_BRANDING_LOGO_STORE_KEY}_API_REQUESTED`,
);
export const uploadOrganizationBrandingLogoSuccess = createAction<{
  organizationId: string;
  logo: UploadedOrganizationBrandingLogo;
}>(`${UPLOAD_ORGANIZATION_BRANDING_LOGO_STORE_KEY}_API_SUCCESS`);
export const uploadOrganizationBrandingLogoFailed = createAction<{ organizationId: string; error: string }>(
  `${UPLOAD_ORGANIZATION_BRANDING_LOGO_STORE_KEY}_API_FAILED`,
);
export const clearUploadedOrganizationBrandingLogo = createAction<{ organizationId: string }>(
  `${UPLOAD_ORGANIZATION_BRANDING_LOGO_STORE_KEY}_CLEAR`,
);

export const previewOrganizationBrandingEmailRequested = createAction<PreviewOrganizationBrandingEmailPayload>(
  `${PREVIEW_ORGANIZATION_BRANDING_EMAIL_STORE_KEY}_API_REQUESTED`,
);
export const previewOrganizationBrandingEmailSuccess = createAction<{
  organizationId: string;
  preview: OrganizationBrandingEmailPreviewDTO;
}>(`${PREVIEW_ORGANIZATION_BRANDING_EMAIL_STORE_KEY}_API_SUCCESS`);
export const previewOrganizationBrandingEmailFailed = createAction<{ organizationId: string; error: string }>(
  `${PREVIEW_ORGANIZATION_BRANDING_EMAIL_STORE_KEY}_API_FAILED`,
);

export const deleteOrganizationBrandingRequested = createAction<DeleteOrganizationBrandingPayload>(
  `${DELETE_ORGANIZATION_BRANDING_STORE_KEY}_API_REQUESTED`,
);
export const deleteOrganizationBrandingSuccess = createAction<{ organizationId: string }>(
  `${DELETE_ORGANIZATION_BRANDING_STORE_KEY}_API_SUCCESS`,
);
export const deleteOrganizationBrandingFailed = createAction<{ organizationId: string; error: string }>(
  `${DELETE_ORGANIZATION_BRANDING_STORE_KEY}_API_FAILED`,
);

export type OrganizationBrandingActionTypes = ReturnType<
  | typeof fetchOrganizationBrandingRequested
  | typeof fetchOrganizationBrandingSuccess
  | typeof fetchOrganizationBrandingFailed
  | typeof upsertOrganizationBrandingRequested
  | typeof upsertOrganizationBrandingSuccess
  | typeof upsertOrganizationBrandingFailed
  | typeof uploadOrganizationBrandingLogoRequested
  | typeof uploadOrganizationBrandingLogoSuccess
  | typeof uploadOrganizationBrandingLogoFailed
  | typeof clearUploadedOrganizationBrandingLogo
  | typeof previewOrganizationBrandingEmailRequested
  | typeof previewOrganizationBrandingEmailSuccess
  | typeof previewOrganizationBrandingEmailFailed
  | typeof deleteOrganizationBrandingRequested
  | typeof deleteOrganizationBrandingSuccess
  | typeof deleteOrganizationBrandingFailed
>;
